module.exports = __webpack_public_path__ + "img/back.a72a96a2.svg";